import { wrapReducer } from "@client/content/lib/helper";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type InitSuccessActionData } from "./actions";
import { type BlogDetailHeader } from "./types";

const reducer = (state: BlogDetailHeader.State, action: ReduxAction<any>): BlogDetailHeader.State => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: Status.Loading
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: Status.Failed
      };
    }
    case Actions.InitSuccess: {
      const post = action.data as InitSuccessActionData;
      return {
        ...state,
        post,
        status: Status.Ready
      };
    }

    default:
      return state;
  }
};

export const defaultState: BlogDetailHeader.State = {
  id: "",
  status: "None",
  post: null
};
export const previewState: BlogDetailHeader.State = {
  id: "",
  status: "Ready",
  post: {
    allowComments: true,
    authorName: "Dummy",
    commentCount: 0,
    excerpt: "Dummy",
    id: "",
    imageUrl: "",
    permalink: "/",
    publishedOnDate: new Date().toISOString(),
    title: "Dummy"
  }
};
export default wrapReducer<BlogDetailHeader.State>({ defaultState, reducer, previewState });
